module.exports = __webpack_public_path__ + "static/media/4.8dcda2df.jpg";